import { isBankTransferAwaitingPayment } from "../ldsOrderStatus";

export const AGENT_DASHBOARD_HOME_PATH = "/p/dashboard";

const AGENT_DASHBOARD_SUCCESS_PATH_RE = /^\/p\/dashboard\/success\/([^/?#]+)\/?$/;

/**
 * @param {string|null|undefined} pathname
 */
export function isAgentDashboardLdsBankTransferSuccessPath(pathname) {
  return AGENT_DASHBOARD_SUCCESS_PATH_RE.test(String(pathname || "").trim());
}

/**
 * @param {string|null|undefined} orderId
 */
export function buildAgentDashboardLdsBankTransferSuccessPath(orderId) {
  const id = orderId == null ? "" : String(orderId).trim();
  if (!id) return null;
  return `/p/dashboard/success/${encodeURIComponent(id)}`;
}

/**
 * @param {string|null|undefined} pathname
 */
export function extractAgentDashboardSuccessOrderId(pathname) {
  const match = String(pathname || "").trim().match(AGENT_DASHBOARD_SUCCESS_PATH_RE);
  if (!match?.[1]) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
}

/**
 * Resolve CTA visibility for agent dashboard LDS bank-transfer success UX.
 * @param {object|null|undefined} orderReqData
 * @param {{
 *   agentDashboardBankTransferSuccess?: boolean,
 *   pathname?: string|null,
 * }} [opts]
 */
export function resolveAgentDashboardBankTransferSuccessCta(orderReqData, opts = {}) {
  const pathname = opts.pathname ?? null;
  const onDashboardSuccessPath = isAgentDashboardLdsBankTransferSuccessPath(pathname);
  const agentMode =
    opts.agentDashboardBankTransferSuccess === true || onDashboardSuccessPath;
  const bank_transfer = Boolean(orderReqData?.bank_transfer);
  const pending = isBankTransferAwaitingPayment(orderReqData);
  const paid = Boolean(orderReqData?.paid);

  if (!agentMode || !pending) {
    return {
      showOnlyHomeButton: false,
      homeButtonLabel: null,
      homeButtonTarget: null,
      visibleButtons: pending && bank_transfer ? ["home", "continue_payment"] : ["continue_payment"],
      hiddenPaymentCtas: [],
      orderId: orderReqData?.id ?? orderReqData?.ID ?? null,
      bank_transfer,
      paid,
      pending,
    };
  }

  return {
    showOnlyHomeButton: true,
    homeButtonLabel: "עמוד הבית",
    homeButtonTarget: AGENT_DASHBOARD_HOME_PATH,
    visibleButtons: ["home"],
    hiddenPaymentCtas: [
      "continue_payment",
      "quick_pay_credit",
      "sticky_payment_bar",
      "receipt_actions",
      "hyp_credit",
    ],
    orderId: orderReqData?.id ?? orderReqData?.ID ?? null,
    bank_transfer,
    paid,
    pending,
  };
}

/**
 * @param {object} payload
 */
export function logBankTransferSuccessPageRouteTrace(payload) {
  if (typeof import.meta !== "undefined" && import.meta.env?.DEV !== true) return;
  try {
    // eslint-disable-next-line no-console
    console.info("[BANK_TRANSFER_SUCCESS_PAGE_ROUTE_TRACE]", payload);
  } catch {
    /* ignore */
  }
}

/**
 * @param {object} payload
 */
export function logBankTransferSuccessCtaTrace(payload) {
  if (typeof import.meta !== "undefined" && import.meta.env?.DEV !== true) return;
  try {
    // eslint-disable-next-line no-console
    console.info("[BANK_TRANSFER_SUCCESS_CTA_TRACE]", payload);
  } catch {
    /* ignore */
  }
}
